/**
 * Created by Julio Perez on 12/19/2016.
 */
import _ from 'underscore';

class FutureCitiesService {
    constructor($sce){

        let vm = this;

        vm.sce = $sce;
        vm.futureCitiesData = require('./data/future-cities-data.json');
        vm.cityData = vm.getData();
        vm.sortBy = '';
        vm.sortOrder = 'descending';


    }


    getSortOrder(isDescending){
        let vm = this;
        if(isDescending){
            vm.sortOrder = 'descending';
        }else{
            vm.sortOrder = 'ascending';
        }
    }

    getData(){
        let vm = this;
        let data = vm.futureCitiesData
            .map(function(item){
                return{
                    city: item.city,
                    region: item.region,
                    country: item.country,
                    per_capita: item.per_capita,
                    spending: vm.getFormatted(item.spending),
                    households: vm.getFormatted(item.households),
                    gva: vm.getFormatted(item.gva),
                    link: vm.sce.trustAsHtml(item.report_link)
                }
            });

        vm.dataValues =  _.sortBy(data, function(obj){ return obj.city });


        return vm.dataValues;
    }


    getMaxValue(metricName){

        let vm = this;
        let maxVal = _.max(vm.cityData
            .map(function(metric){
                    return metric[metricName];
                })
            );

        return maxVal
    }

    getFormatted(value){
        return parseInt(value * 100);
    }

}

export default angular
    .module('futureCitiesService', [])
    .service('futureCitiesService', FutureCitiesService)
    .name;

FutureCitiesService.$inject = ['$sce'];


// WEBPACK FOOTER //
// ./src/app/services/future-cities.service.js